import {FundraiserImages, ImageType, useAppealsImages} from '../../features';
import styles from './FundraiserImageVideoWidget.module.scss';
import {useParams} from 'react-router';

export const FundraiserImageVideoWidget = () => {
  const {id} = useParams<{id: string}>();
  const {getAppealsImages} = useAppealsImages({fundraiserId: id || ''});

  const defaultImages = {
    avatar: {fileName: '', url: ''},
    mainImages: [],
    feedImages: [],
  };

  return (
    <div className={styles.container}>
      <FundraiserImages
        aspectRatio={1}
        title={'Аватар'}
        imageType={ImageType.AVATAR}
        images={getAppealsImages.data || defaultImages}
      />
      <FundraiserImages
        title={'Список сборов'}
        imageType={ImageType.FEED}
        images={getAppealsImages.data || defaultImages}
      />
      <FundraiserImages
        aspectRatio={1}
        title={'Карточка сбора'}
        imageType={ImageType.MAIN}
        images={getAppealsImages.data || defaultImages}
      />
    </div>
  );
};
